import { OverlappingAbsenceDTO } from "../../models/tna/tna-overlapping-absences/tna-overlapping-absence-dto";
import { BaseApiService } from "../base/base-api.service";

export class OverlappingAbsencesApiService extends BaseApiService<OverlappingAbsenceDTO, OverlappingAbsenceDTO> {
  constructor() {
    super({
      servicePath: "/TnAAbsences",
      loadItemsPath: "/GetOverlappingAbsences",
    });
  }
}
